import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Notify from './components/Notify';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import Home from './pages/HomePage';
import Contacts from './pages/ContactsPage';
import About from './pages/AboutPage';
import Catalog from './pages/CatalogPage';
import ProductPage from './pages/ProductPage';

import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminCategories from './pages/admin/AdminCategories';
import AdminProjectCategories from './pages/admin/AdminProjectCategories';
import AdminProjectCategoryEdit from './pages/admin/AdminProjectCategoryEdit';
import AdminCategoryEdit from './pages/admin/AdminCategoryEdit';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductEdit from './pages/admin/AdminProductEdit';

import './App.css';

function App() {
    const notification = useSelector(state => state.notification);

    return (
        <BrowserRouter>
            <ScrollToTop />
            <div className="app-container">
                {notification && <Notify message={notification.message} type={notification.type} />}
                <Routes>
                    {/* Основной сайт */}
                    <Route element={<MainLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/contacts" element={<Contacts />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/catalog" element={<Catalog />} />
                        <Route path="/catalog/:categoryName" element={<Catalog />} />
                        <Route path="/catalog/:categoryName/:productNameWithId" element={<ProductPage />} />
                    </Route>

                    {/* Публичная страница логина */}
                    <Route path="/performance-admin-panel/login" element={<AdminLogin />} />

                    {/* Защищенная часть админки */}
                    <Route element={<ProtectedRoute />}>
                        <Route path="/performance-admin-panel" element={<AdminLayout />}>
                            <Route index element={<Navigate to="products" replace />} />
                            <Route path="categories" element={<AdminCategories />} />
                            <Route path="categories/:id" element={<AdminCategoryEdit />} />
                            <Route path="products" element={<AdminProducts />} />
                            <Route path="products/:id" element={<AdminProductEdit />} />
                            <Route path="project-categories" element={<AdminProjectCategories />} />
                            <Route path="project-categories/:categoryName" element={<AdminProjectCategoryEdit />} />
                        </Route>
                    </Route>
                </Routes>
            </div>
            <CookieConsent />
        </BrowserRouter>
      );
}

export default App;
